var map = {
	"./sdg_small_1.png": "bfdb",
	"./sdg_small_10.png": "34bf",
	"./sdg_small_11.png": "62eb",
	"./sdg_small_12.png": "2757",
	"./sdg_small_13.png": "bb67",
	"./sdg_small_14.png": "2c3d",
	"./sdg_small_15.png": "45f5",
	"./sdg_small_16.png": "b8d9",
	"./sdg_small_17.png": "660f",
	"./sdg_small_2.png": "1c0a",
	"./sdg_small_3.png": "873c",
	"./sdg_small_4.png": "38ac",
	"./sdg_small_5.png": "dae0",
	"./sdg_small_6.png": "c18c",
	"./sdg_small_7.png": "b09c",
	"./sdg_small_8.png": "1d8e",
	"./sdg_small_9.png": "86c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "542a";